
import { MarketingHomepage } from '@/components/MarketingHomepage';

const Home = () => {
  return <MarketingHomepage />;
};

export default Home;
